import { Component, inject, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ROUTES } from "../../constants/routes";
import { Navbar } from "../../components/navbar/navbar";
import { Footer } from "../../components/footer/footer";
import { SeoService } from "../../services/seo.service";

@Component({
  selector: "app-not-found",
  imports: [RouterLink, Navbar, Footer],
  templateUrl: "./not-found.html",
  styleUrl: "./not-found.scss"
})
export class NotFound implements OnInit {
  readonly routes = ROUTES;
  private readonly seo = inject(SeoService);

  readonly suggestions = [
    { label: "How it works", url: ROUTES.howItWorks.url, note: "Upload, match and verify in minutes" },
    { label: "Pricing", url: ROUTES.pricing.url, note: "Pay per verified record from $0.01" },
    { label: "Solutions", url: ROUTES.solutions.url, note: "Built for banks, lenders and insurers" },
    { label: "Developers", url: ROUTES.developers.url, note: "REST API reference and examples" },
    { label: "FAQ", url: ROUTES.faq.url, note: "Common questions answered" },
    { label: "Contact", url: ROUTES.contact.url, note: "Talk to the team about your use case" }
  ];

  ngOnInit(): void {
    this.seo.apply({
      title: "Page Not Found",
      description:
        "The page you are looking for does not exist or has moved. Browse VerifyDeceased deceased verification, pricing, solutions and API documentation instead.",
      path: "/404",
      robots: "noindex, follow"
    });
  }
}
